


export const ThriveLink_START = 'ThriveLink_START';
export const ThriveLink_END = 'ThriveLink_END';
export const ThriveLink_ERROR = 'ThriveLink_ERROR';
export const ThriveLink_SUCCESS = 'ThriveLink_SUCCESS';
export const ThriveLink_FAIL = 'ThriveLink_FAIL';
export const IsDataSubmitedSuccessfully = 'IsDataSubmitedSuccessfully'